import UX from './assets/ux.png'
import marketting from './assets/marketting.png'
import html from './assets/html.png'
import javascript from './assets/javascript.png'
import outroom from './assets/outroom.png'
import analysis from './assets/analysis.png'
import leonard from './assets/leonard.png'
import jeffery from './assets/jeffery.png'
import claretta from './assets/clarity.png'
import jessica from './assets/jessica.png'
import samuel from './assets/samuel.png'
import adam from './assets/adam.png'

import bella from './assets/bella.png'
import vic from './assets/vic.png'
import jes from './assets/jes.png'

export const courses = [
    {
        id: 1,
        img: UX,
        genre: 'design',
        title: 'Introduction to User research in UX Design',
        time: '23hrs 50min',
        lessons: '15',
        author: "Leaonard Victor",
        authorimg: leonard,
        price: "15.00",
        rating: '4.7k',
        ratingpercent: '32.7k +',
    },
    {
        id: 2,
        img: marketting,
        genre: 'marketting',
        title: 'introduction to new marketing audience',
        time: '23hrs 50min',
        lessons: '15',
        author: "Leaonard Victor",
        authorimg: jeffery,
        price: "15.00",
        rating: '4.7k',
        ratingpercent: '32.7k +',
    },
    {
        id: 3,
        img: html,
        genre: 'marketting',
        title: 'introduction to html, css and bootstrap',
        time: '23hrs 50min',
        lessons: '15',
        author: "Leaonard Victor",
        authorimg: claretta,
        price: "15.00",
        rating: '4.7k',
        ratingpercent: '32.7k +',
    },
    {
        id: 4,
        img: javascript,
        genre: 'development',
        title: 'introduction to javascript, git and github',
        time: '23hrs 50min',
        lessons: '15',
        author: "Leaonard Victor",
        authorimg: jessica,
        price: "15.00",
        rating: '4.7k',
        ratingpercent: '32.7k +',
    },
    {
        id: 5,
        img: outroom,
        genre: 'development',
        title: 'introduction to outroom marketing analysis',
        time: '23hrs 50min',
        lessons: '15',
        author: "Leaonard Victor",
        authorimg: samuel,
        price: "15.00",
        rating: '4.7k',
        ratingpercent: '32.7k +',
    },
    {
        id: 6,
        img: analysis,
        genre: 'development',
        title: 'introduction to live marketing analysis',
        time: '23hrs 50min',
        lessons: '15',
        author: "Leaonard Victor",
        authorimg: adam,
        price: "15.00",
        rating: '4.7k',
        ratingpercent: '32.7k +',
    },
]
export  const test = [
    {
        id: 1,
        name: "Bella Moon",
        img: bella,
        test: 'High-defination video is video of higher resolution and quality than standard definition. high-defination video is video of higher resolution and quality than standard definition. hbuild your future with our quality education. the best and largest all-in-one online tutoring platform in the worldd definition. high-defination video is video of higher resolution and quality than standard definition. build your future with our quality education. the best and largest all-in-one online tutoring platform in the world',
        proffession: 'Product Designer',
    },
    {
        id: 2,
        name: "Jessica Boar",
        img: jes,
        test: 'High-defination video is video of higher resolution and quality than standard definition. high-defination video is video of higher resolution and quality than standard definition. hbuild your future with our quality education. the best and largest all-in-one online tutoring platform in the worldd definition. high-defination video is video of higher resolution and quality than standard definition. build your future with our quality education. the best and largest all-in-one online tutoring platform in the world',
        proffession: 'Frontend developer'
    },
    {
        id: 3,
        name: "Victor James",
        img: vic,
        test: 'High-defination video is video of higher resolution and quality than standard definition. high-defination video is video of higher resolution and quality than standard definition. hbuild your future with our quality education. the best and largest all-in-one online tutoring platform in the worldd definition. high-defination video is video of higher resolution and quality than standard definition. build your future with our quality education. the best and largest all-in-one online tutoring platform in the world',
        proffession: "Senior UI/UX Designer"
    },
    {
        id: 4,
        name: "Victor James",
        img: vic,
        test: 'High-defination video is video of higher resolution and quality than standard definition. high-defination video is video of higher resolution and quality than standard definition. hbuild your future with our quality education. the best and largest all-in-one online tutoring platform in the worldd definition. high-defination video is video of higher resolution and quality than standard definition. build your future with our quality education. the best and largest all-in-one online tutoring platform in the world',
        proffession: "Senior UI/UX Designer"
    },
    {
        id: 5,
        name: "Victor James",
        img: vic,
        test: 'High-defination video is video of higher resolution and quality than standard definition. high-defination video is video of higher resolution and quality than standard definition. hbuild your future with our quality education. the best and largest all-in-one online tutoring platform in the worldd definition. high-defination video is video of higher resolution and quality than standard definition. build your future with our quality education. the best and largest all-in-one online tutoring platform in the world',
        proffession: "Senior UI/UX Designer"
    },
    
]